import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { calculateProjectionMatrix } from './utils';
import { MercatorCoordinate } from 'mapbox-gl';
export class Model3D {
    constructor(object, index) {
        this.initialRender = true;
        this.object = object;
        this.index = index;
        this.id = `3dObjects-${index}`;
        this.renderingMode = '3d';
        this.type = 'custom';
        const mercCoord = MercatorCoordinate.fromLngLat([object.longitude, object.latitude], object.altitude);
        this.transform = {
            translateX: mercCoord.x,
            translateY: mercCoord.y,
            translateZ: mercCoord.z || 0,
            rotateX: Math.PI / 2,
            rotateY: THREE.MathUtils.degToRad(object.rotation),
            rotateZ: 0,
            scale: (1 / 1024000) * 0.001 * object.scale
        };
    }
    onAdd(map, gl) {
        this.map = map;
        this.camera = new THREE.Camera();
        this.scene = new THREE.Scene();
        const loader = new GLTFLoader();
        loader.load(this.object.fileLocation, gltf => {
            if (this.scene) {
                this.scene.add(gltf.scene);
            }
        }, () => { }, err => {
            throw err;
        });
        const directionalLight = new THREE.DirectionalLight(0xffffff, 1);
        directionalLight.castShadow = true;
        directionalLight.position.set(0, 1, 0).normalize();
        this.scene.add(directionalLight);
        const light = new THREE.AmbientLight(0xffffff);
        light.intensity = 1.7;
        this.scene.add(light);
        if (!this.renderer && this.map) {
            this.renderer = new THREE.WebGLRenderer({
                canvas: this.map.getCanvas(),
                context: gl,
                antialias: true,
            });
            this.renderer.outputColorSpace = THREE.LinearSRGBColorSpace;
            THREE.ColorManagement.enabled = false;
            this.renderer.useLegacyLights = true;
            this.renderer.autoClear = false;
        }
    }
    render(gl, matrix) {
        if (!window.mapShown) {
            return;
        }
        if (this.renderer && this.scene && this.camera) {
            this.camera.projectionMatrix = calculateProjectionMatrix(matrix, this.transform);
            this.renderer.resetState();
            this.renderer.render(this.scene, this.camera);
        }
        if (this.initialRender && this.map) {
            this.map.triggerRepaint();
            this.initialRender = false;
        }
    }
}
//# sourceMappingURL=Model3D.js.map